import React from 'react';
import '../css/work_experience.css'; // New styles for the work experience page
import '../css/style.css'; // Global styles

function WorkExperience() {
  return (
    <div className="work-experience-page-container">
      <h1 className="section-title text-center mb-5">Work Experience</h1>

      <div className="experience-grid">
        <div className="experience-card">
          <div className="company-logo-container">
            <img src="/images/sigma.png" alt="Sigma Computing Inc Logo" className="company-logo" />
          </div>
          <div className="experience-content-main">
            <h2 className="experience-role">Security Engineering Intern</h2>
            <p className="experience-company">Sigma Computing Inc</p>
            <p className="experience-dates">San Francisco, USA | Jun 2025 – Sept 2025</p>
            <h4 className="achievements-title">Key Achievements:</h4>
            <ul className="achievements-list">
              <li>Designed and implemented a fully automated CTI pipeline that processed over 100K+ IOCs daily, resulting in $80K annual savings in operational costs</li>
              <li>Successfully launched and scheduled 12 phishing attack simulations using SANS, significantly improving employee security awareness</li>
              <li>Monitored 20+ enterprise applications through a real-time Sigma BI dashboard for executive-grade budgeting and cost optimization</li>
              <li>Developed custom detections on SIEM platform, achieving a 20% reduction in false positives</li>
              <li>Validated 100% Azure log coverage in Log Analytics and Panther, ensuring comprehensive visibility across AWS and GCP</li>
              <li>Enhanced DLP policies in Netskope and implemented strategic block rules for business-critical applications</li>
            </ul>
          </div>
        </div>

        <div className="experience-card">
          <div className="company-logo-container">
            <img src="/images/deloitte.png" alt="Deloitte India (Offices of the US) Logo" className="company-logo" />
          </div>
          <div className="experience-content-main">
            <h2 className="experience-role">Security Operations Analyst</h2>
            <p className="experience-company">Deloitte & Touche LLP</p>
            <p className="experience-dates">Bengaluru, India | Jan 2023 – Aug 2024</p>
            <h4 className="achievements-title">Key Achievements:</h4>
            <ul className="achievements-list">
              <li>Led analysis of 10,000+ assets during a major cyberattack, reducing potential impact by 90% through rapid identification of critical vulnerabilities</li>
              <li>Spearheaded rapid incident response for a trojan attack, successfully remediating 200+ endpoints within 4 days</li>
              <li>Automated 16+ repetitive SOC tasks using Python and Sentinel APIs, significantly improving operational efficiency</li>
              <li>Mentored 10+ new analysts through structured knowledge transfer programs focused on threat detection and response</li>
            </ul>
          </div>
        </div>

        <div className="experience-card">
          <div className="company-logo-container">
            <img src="/images/deloitte.png" alt="Deloitte India (Offices of the US) Logo" className="company-logo" />
          </div>
          <div className="experience-content-main">
            <h2 className="experience-role">Solution Delivery Analyst</h2>
            <p className="experience-company">Deloitte India (Offices of the US)</p>
            <p className="experience-dates">Bengaluru, India | Jul 2022 - Dec 2022</p>
            <h4 className="achievements-title">Key Achievements:</h4>
            <ul className="achievements-list">
              <li>Improved compliance by 20% through development of secure identity controls for 100+ Azure resources</li>
              <li>Achieved 25% faster deployments by optimizing Azure DevOps pipelines with automation</li>
              <li>Designed and implemented scalable IAM policies supporting 500+ users across the organization</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <span>Scroll to see more</span>
        <i className="fas fa-arrow-right scroll-arrow"></i>
      </div>
    </div>
  );
}

export default WorkExperience;
